function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Oval");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel_Artikel",
  transform: "translate(-350.000000, -313.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Produktname_001",
  transform: "translate(330.000000, 92.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval",
  transform: "translate(20.000000, 221.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#DD5860",
  strokeWidth: 0.5,
  cx: 4.5,
  cy: 4.5,
  r: 4.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.73046875,5.08203125 L4.078125,5.08203125 L4.02734375,2 L4.78515625,2 L4.73046875,5.08203125 Z M4,6.32421875 C4,6.20703066 4.03580693,6.10872436 4.10742188,6.02929688 C4.17903682,5.94986939 4.28515555,5.91015625 4.42578125,5.91015625 C4.56640695,5.91015625 4.67317672,5.94986939 4.74609375,6.02929688 C4.81901078,6.10872436 4.85546875,6.20703066 4.85546875,6.32421875 C4.85546875,6.44140684 4.81901078,6.53841107 4.74609375,6.61523438 C4.67317672,6.69205768 4.56640695,6.73046875 4.42578125,6.73046875 C4.28515555,6.73046875 4.17903682,6.69205768 4.10742188,6.61523438 C4.03580693,6.53841107 4,6.44140684 4,6.32421875 Z",
  id: "!",
  fill: "#DD5860",
  fillRule: "evenodd"
})))));

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "9px",
    viewBox: "0 0 9 9",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.5886ae36.svg";
export { ForwardRef as ReactComponent };